"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhatIsMatchFactorButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _useMatchFactorDescriptionDrawer = require("./use-match-factor-description-drawer");

var _jsxRuntime = require("react/jsx-runtime");

var CircleFaqIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).attrs(function () {
  return {
    name: 'actions/circle-faq'
  };
}).withConfig({
  displayName: "CircleFaqIcon",
  componentId: "sc-kh07us-0"
})(["background-color:", ";fill:white;border-radius:100%;height:22px;width:22px;padding:0.18em;box-sizing:border-box;"], function (_ref) {
  var theme = _ref.theme;
  return theme.bubbleBlue400;
});

var Container = _styledComponents["default"].span.withConfig({
  displayName: "Container",
  componentId: "sc-kh07us-1"
})(["display:inline-flex;align-items:center;gap:10px;cursor:pointer;"]);

var WhatIsMatchFactorButton = function WhatIsMatchFactorButton() {
  var showMatchFactorDescriptionDrawer = (0, _useMatchFactorDescriptionDrawer.useMatchFactorDescriptionDrawer)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    onClick: showMatchFactorDescriptionDrawer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CircleFaqIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      children: "What is MatchFactor?"
    })]
  });
};

exports.WhatIsMatchFactorButton = WhatIsMatchFactorButton;
//# sourceMappingURL=what-is-match-factor-button.js.map